module.exports = __webpack_public_path__ + "img/logoyipi2.f78fa0a1.svg";